import { createRouter, createWebHistory } from "vue-router"
import Sidebar from "./sidebar.vue"
import MixListPage from "./pages/mix_list_page.vue"
import PlaylistPage from "./pages/playlist_page.vue"
import UploadPage from "./pages/upload_page.vue"
import MixEditPage from "./pages/mix_edit_page.vue"

export default createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/latest" },
    { path: "/mixes/new", components: { sidebar: Sidebar, default: UploadPage } },
    { path: "/mixes/:mixID/edit", components: { sidebar: Sidebar, default: MixEditPage } },
    { path: "/latest", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/all", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/artists/:artistID", redirect: to => `/artists/${to.params.artistID}/latest` },
    { path: "/artists/:artistID/latest", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/artists/:artistID/all", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/artists/:artistID/song/:songId", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/mixes/:mixID", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/songs/:songID", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/playlists/:playlistID", components: { sidebar: Sidebar, default: PlaylistPage } },
    { path: "/shared/artists/:artistID/latest", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/shared/artists/:artistID/all", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/shared/songs/:songID", components: { sidebar: Sidebar, default: MixListPage } },
    { path: "/shared/playlist/:playlistID", components: { sidebar: Sidebar, default: PlaylistPage } },
  ],
})
